import React, { useEffect, Fragment, useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { UploadPhoto, Spinner } from 'triider-components';

import closeIcon from 'assets/img/icons/close-overlay.svg';
import pdfIcon from 'assets/img/icons/pdf.svg';

import { Creators as TaskCreators } from 'store/ducks/task';

import Modal from 'components/Modal';
import { ButtonCopyCheckoutLink } from 'config/shared';
import CancelModal from '../OrderModals/CancelModal';
import PlayerModal from '../OrderModals/PlayerModal';


import { gaSendEvent } from '../../../../utils/analytics';

import {
  OrdersDetails,
  CancelBtn,
  QuestionsLeft,
  Question,
  Title,
  Answer,
  DetailsRight,
  PhotoGrid,
  PhotoContainer,
  Photo,
  DeleteButton,
  BigPicture,
  SpinnerContainer,
  AddText,
  ModalPhoto,
} from './styles';

const MapTaskQuestions = ({ username, questions }) => (
  <ul>
    <Question>
      <Title>Solicitado por:</Title>
      <Answer>{username}</Answer>
    </Question>
    {questions.map(question => (
      <Question key={question.id}>
        <Title>{question.service_field_name}</Title>
        <Answer>{question.service_field_option_name || question.value}</Answer>
      </Question>
    ))}
  </ul>
);

const DetailsTab = ({
  taskDetail,
  _addPhotosToTaskRequest,
  _removePhotosFromTaskRequest,
  addPhotoIsLoading,
}) => {
  const [fieldsData, setFieldsData] = useState([]);
  const [openedPicture, setOpenedPicture] = useState(false);
  const [openedPictureModalIsOpen, setOpenedPictureModalIsOpen] = useState(false);
  const [cancelModalIsOpen, setCancelModalIsOpen] = useState(false);
  const [uploadPhotoModalIsOpen, setUploadPhotoModalIsOpen] = useState(false);
  const [playerOpen, setPlayerOpen] = useState(false);
  const [sourceVideo, setSourceVideo] = useState(false);
  const [thumbnail, setThumbnail] = useState(false);
  const [lastTaskQuestions, setLastTaskQuestions] = useState([]);
  const [deletePhotoModalIsOpen, setDeletePhotoModalIsOpen] = useState(false);
  const [photoToDelete, setPhotoToDelete] = useState({});

  useEffect(() => {
    setUploadPhotoModalIsOpen(false);
  }, [taskDetail]);

  const getFields = () => {
    let fields = [];
    if (taskDetail && taskDetail.fields) {
      taskDetail.fields.forEach((field) => {
        const alreadyInQuestions = fields.find(
          actualField => actualField.service_field_id === field.service_field_id,
        );
        if (alreadyInQuestions) {
          fields = fields.filter(
            actualField => actualField.service_field_id !== field.service_field_id,
          );
          const parsedField = {
            ...field,
            service_field_option_name: `${alreadyInQuestions.service_field_option_name}; ${field.service_field_option_name}`,
          };
          fields.push(parsedField);
        } else {
          fields.push(field);
        }
      });
    }
    return fields;
  };

  useEffect(() => {
    setFieldsData(getFields());
    // Setar os campos de perguntas que user selecionou ao criar o pedido
    // validar se a ultima questão é de detalhes adicionais
    if (fieldsData.length && !lastTaskQuestions.length) {
      if (
        fieldsData[fieldsData.length - 1].value
        && fieldsData[fieldsData.length - 1].value.length
      ) {
        setLastTaskQuestions(
          fieldsData.filter((field, i) => (i !== fieldsData.length - 1 ? field : null)),
        );
      } else {
        setLastTaskQuestions(fieldsData);
      }
    }
  }, [taskDetail, fieldsData.length]);

  const makeQuestion = (id, service_field_name, service_field_option_name) => ({
    id,
    service_field_name,
    service_field_option_name,
  });

  const firstTaskQuestions = [
    makeQuestion(-2, 'SERVIÇO PEDIDO EM:', moment(taskDetail.created).format('DD/MM/YYYY')),
    makeQuestion(-1, 'ENDEREÇO:', taskDetail.address),
  ];

  if (taskDetail.period_text) {
    firstTaskQuestions.push(makeQuestion(-3, 'MELHOR HORÁRIO:', taskDetail.period_text));
  }

  if (taskDetail.specific_date) {
    firstTaskQuestions.push(
      makeQuestion(-4, 'QUANDO:', moment(taskDetail.specific_date).format('DD/MM/YYYY')),
    );
  } else if (taskDetail.time_text) {
    firstTaskQuestions.push(makeQuestion(-5, 'QUANDO:', taskDetail.time_text));
  }

  const getQuestions = [...firstTaskQuestions, ...lastTaskQuestions];
  const getMoreDetails = fieldsData.filter((field, i) => (i === fieldsData.length - 1 ? field : null));
  const canCancel = taskDetail.status === 'open' || taskDetail.status === 'hired';

  const savePhotos = (photos) => {
    const taskId = taskDetail.id;
    _addPhotosToTaskRequest({ taskId, photos });
  };

  const openDeletePhotoModal = (photo) => {
    setDeletePhotoModalIsOpen(true);
    setPhotoToDelete(photo);
  };

  const closeDeletePhotoModal = () => {
    setPhotoToDelete({});
    setDeletePhotoModalIsOpen(false);
  };

  const deletePhoto = () => {
    _removePhotosFromTaskRequest(photoToDelete);
    closeDeletePhotoModal();
  };

  const checkMedia = (e) => {
    const { target } = e;
    target.setAttribute('type', 'pdf');
    target.setAttribute('src', pdfIcon);
  };

  const open = (e, photo) => {
    const check = e.target.hasAttribute('type');
    check
      ? window.open(photo.url)
      : [setOpenedPictureModalIsOpen(true), setOpenedPicture(photo)];
  };

  const openCancelTask = () => {
    gaSendEvent('cancelar_pedido', 'detalhes_pedido', `${taskDetail.id}`);
    setCancelModalIsOpen(!cancelModalIsOpen);
  };

  return (
    <OrdersDetails>
      {canCancel && <CancelBtn onClick={() => openCancelTask()}>Cancelar Pedido</CancelBtn>}
      <ButtonCopyCheckoutLink id="copy-to-clipboard" task={taskDetail} />
      {fieldsData && fieldsData.length > 0 && (
        <Fragment>
          <QuestionsLeft>
            <MapTaskQuestions username={taskDetail.user_name} questions={getQuestions} />
          </QuestionsLeft>
          <DetailsRight>
            {getMoreDetails && getMoreDetails[0].value && (
              <MapTaskQuestions questions={getMoreDetails} />
            )}

            {taskDetail.photos && taskDetail.photos.length > 0 && (
              <Fragment>
                <Title>Fotos anexadas:</Title>
                <PhotoGrid>
                  {taskDetail.photos.map(photo => (
                    <PhotoContainer key={photo.id}>
                      <DeleteButton
                        onClick={() => openDeletePhotoModal(photo)}
                        src={closeIcon}
                        alt="Deletar imagem"
                      />
                      <Photo src={photo.url} onClick={e => open(e, photo)} onError={checkMedia} />
                      {photo.name && <p>{photo.name.substring(0, 14)}</p>}
                    </PhotoContainer>
                  ))}
                </PhotoGrid>
              </Fragment>
            )}

            {canCancel && (
              <Fragment>
                {addPhotoIsLoading ? (
                  <SpinnerContainer>
                    <Spinner size="small" />
                  </SpinnerContainer>
                ) : (
                  <AddText>
                    <span onClick={() => setUploadPhotoModalIsOpen(!uploadPhotoModalIsOpen)}>
                      Adicionar Fotos
                      {' '}
                    </span>
                  </AddText>
                )}
              </Fragment>
            )}
          </DetailsRight>
        </Fragment>
      )}

      <PlayerModal open={playerOpen} close={setPlayerOpen} source={sourceVideo} />

      <Modal
        isOpen={openedPictureModalIsOpen}
        toggle={() => {
          setOpenedPictureModalIsOpen(false);
          setOpenedPicture({});
        }}
        title={openedPicture.description ? openedPicture.description : 'FOTOS ANEXADAS'}
        width="800px"
      >
        <BigPicture>
          <img src={openedPicture.url} alt="big service" />
        </BigPicture>
      </Modal>

      <CancelModal
        cancelModalIsOpen={cancelModalIsOpen}
        setCancelModalIsOpen={setCancelModalIsOpen}
        taskDetail={taskDetail}
      />

      <ModalPhoto>
        <UploadPhoto
          open={uploadPhotoModalIsOpen}
          close={() => setUploadPhotoModalIsOpen(!uploadPhotoModalIsOpen)}
          getPhotos={savePhotos}
        />
      </ModalPhoto>

      <Modal
        isOpen={deletePhotoModalIsOpen}
        toggle={() => closeDeletePhotoModal()}
        title="EXCLUIR FOTO"
        footerClick={() => deletePhoto()}
        footer="Deletar Foto"
      >
        <p>Tem certeza que deseja excluir esta foto?</p>
      </Modal>
    </OrdersDetails>
  );
};

const mapStateToProps = state => ({
  taskDetail: state.task.taskDetail,
  addPhotoIsLoading: state.ui.loaders.includes('TASK_ADD_PHOTO'),
  playerLoading: state.ui.loaders.includes('TASK_PLAY_VIDEO'),
});

const mapDispatchToProps = {
  _addPhotosToTaskRequest: TaskCreators.addPhotosToTaskRequest,
  _removePhotosFromTaskRequest: TaskCreators.removePhotosFromTaskRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsTab);
